export default __webpack_public_path__ + "assets/images/f0582a43cb897fceaabc9894306354f4.png";